<template>
  <v-card class="align-stretch" height="100%" :loading="getIsTelcoProvisioningLoading">

    <v-card-title>
      Line 
      <BeehiveIcon :link="articleLinks.lineTelco" />

      <v-spacer></v-spacer>

      <v-btn v-if="!getTelcoProvisioning.address_ref && !getIsTelcoProvisioningLoading && hasUserGotRoles(['can-generate-new-telco-addresses'])" color="secondary" class="ml-2" x-small :loading="getTelcoCreateAddressLoading" @click="createNewAddressBtn">Create address</v-btn>

      <v-btn color="secondary" class="ml-2" x-small @click="editLine=true;"><v-icon small>edit</v-icon></v-btn>

    </v-card-title>

    <v-card-text>
      
      <v-row>
        <v-col>
          <p class="mb-1 text-caption">Line Number / Service ID</p>
          <p class="display-1 accent--text">{{getTelcoProvisioning.line_number | customPlaceholder}}</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <p class="mb-1 text-caption">Line Address
            <template v-if="getTelcoProvisioning.line_address_category">- <v-icon small :class="`${getTelcoProvisioning.line_address_category}`">{{addressIcon}}</v-icon> ({{getTelcoProvisioning.line_address_category}})</template>
          </p>

          <p>
            <template v-if="getTelcoProvisioning.line_address && getTelcoProvisioning.line_address.line_one">
              <b>{{getTelcoProvisioning.line_address.line_one | customPlaceholder}}</b><br>
              <b>{{getTelcoProvisioning.line_address.city | customPlaceholder}}</b><br>
              <b>{{getTelcoProvisioning.line_address.county | customPlaceholder}}</b><br>
              <b>{{getTelcoProvisioning.line_address.country | customPlaceholder}}</b><br>
              <b>{{getTelcoProvisioning.line_address.post_code | customPlaceholder}}</b>
            </template>
            <template v-else><b>-</b></template>
          </p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">Address Reference</p>
          <p><b>{{getTelcoProvisioning.address_ref | customPlaceholder}}</b></p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">Access Line ID</p>
          <p><b>{{getTelcoProvisioning.access_line_id | customPlaceholder}}</b></p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">CSS Database Code</p>
          <p><b>{{getTelcoProvisioning.css_database_code | customPlaceholder}}</b></p>
        </v-col>

         <v-col cols="12" md="6">
          <p class="mb-1 text-caption">Access CASR</p>
          <p><b>{{ getTelcoProvisioning.access_casr | customPlaceholder }}</b></p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">ONT Reference</p>
          <p><b>{{ getTelcoProvisioning.ont_reference | customPlaceholder }}</b></p>
        </v-col>

        <v-col cols="12" md="6">
          <p class="mb-1 text-caption">ONT Serial Number</p>
          <p><b>{{ getTelcoProvisioning.ont_serial_number | customPlaceholder }}</b></p>
        </v-col>
      </v-row>
    </v-card-text>

    <EditLine :dialogOpen="editLine" @close-dialog="editLine=false" />
  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { mdiCheckboxBlankCircle } from '@mdi/js';

  import EditLine from './EditLine';
  import BeehiveIcon from '@/components/Globals/BeehiveIcon';
  import { articleLinks } from '@/helpers/links';

  export default {

    components: {EditLine, BeehiveIcon},

    data() {
      return {
        editLine: false,
        addressIcon: mdiCheckboxBlankCircle,
        articleLinks,
      }
    },

    computed: {
      ...mapGetters('products',['getCurrentProduct']),
      ...mapGetters('productTelco',['getTelcoProvisioning','getIsTelcoProvisioningLoading']),
      ...mapGetters('productCli',['getTelcoCreateAddressLoading', 'getTelcoCreateAddressError']),
      ...mapGetters("globals", ["hasUserGotRoles"]),
    },

    methods: {
      ...mapActions("productCli", ['createNewAddress']),
      ...mapActions('productTelco', ['fetchTelcoProvisioning']),

      async createNewAddressBtn() {
        if(confirm('Are you sure you want to create the address? This will generate a new address reference.')) {
          const product_id = this.$route.params.id;
          await this.createNewAddress({ product_id });
          if(!this.getTelcoCreateAddressError) {
            this.fetchTelcoProvisioning(product_id);
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .BRONZE{ color: #CD7F32 !important; }
  .SILVER{ color: #C4C4C4 !important; }
  .GOLD{ color: #FFD700 !important; }
</style>
